 
import { createSlice } from '@reduxjs/toolkit';

// Initial state now includes an array of products and the cart
const initialState = {
  products: [], // Array to hold the list of products
  cart: [], 
  wishList: [],    // Cart to hold products with quantities
  compare:[],
  selectedProduct: null,
  selectedProductStore: null,
  selectedPayemntMethode: null,


  selectedProduct: {
    id: null,
    name: '',
    description: '',
    brand: '',
    taxRate: 0,
    benefice: 0,
    commution: 0,
    price: 0,
    discount: 0,
    stock: 0,
    sku: '',
    ratings: 0,
    status: '',
    categories: {
      id: null,
      name: '',
    },
    subCategories: {
      id: null,
      name: '',
      category: {
        id: null,
        name: '',
      },
    },
    images: [],
    featured: false,
  },};

/**
 * Product Slice.
 */
export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // Action to set a single product details
    setProduct: (state, action) => {
      const product = action.payload;
      state.selectedProduct = {
        ...state.selectedProduct,
        ...product,
      };
    },

        
    // Action to set a list of products
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setProductsStore: (state, action) => {
      state.products = action.payload;
    },
    selectedPayemntMethode: (state, action) => {
      state.selectedPayemntMethode = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setSelectedProductStore: (state, action) => {
      state.selectedProductStore = action.payload;
    },
    // Action to reset product details to initial state
    resetProduct: (state) => {
      state.selectedProduct = initialState.selectedProduct;
    },

    // Action to reset the list of products
    resetProducts: (state) => {
      state.products = [];
    },

    // Action to add a new product to the list
    addProduct: (state, action) => {
      state.products.push(action.payload);
    },

    // Action to update an existing product in the list
    updateProduct: (state, action) => {
      const updatedProduct = action.payload;
      const index = state.products.findIndex((product) => product.id === updatedProduct.id);

      if (index !== -1) {
        state.products[index] = updatedProduct;
      }
    },

    // Action to add a product to the cart 
    addToCart: (state, action) => {
      const productToAdd = action.payload;
      const existingProductIndex = state.cart.findIndex((product) => product.id === productToAdd.id);
    
      console.log("Existing product index:", existingProductIndex);
      if (existingProductIndex !== -1) {
        state.cart[existingProductIndex].quantity += 1;
      } else {
        state.cart.push({ ...productToAdd, quantity: 1 });
      }
    
      console.log("Updated cart:", [...state.cart]); // Display updated cart
    },
    addToWishList: (state, action) => {
      const productToAdd = action.payload;
      const existingProductIndex = state.wishList.findIndex((product) => product.id === productToAdd.id);
    
      console.log("Existing product index:", existingProductIndex);
      if (existingProductIndex !== -1) {
        state.wishList[existingProductIndex].quantity += 1;
      } else {
        state.wishList.push({ ...productToAdd, quantity: 1 });
      }
    
      console.log("Updated wishList:", [...state.wishList]); // Display updated cart
    },
    addToCompare: (state, action) => {
      const productToAdd = action.payload;
      const existingProductIndex = state.compare.findIndex((product) => product.id === productToAdd.id);
    
      console.log("Existing product index:", existingProductIndex);
      if (existingProductIndex !== -1) {
        state.compare[existingProductIndex].quantity += 1;
      } else {
        state.compare.push({ ...productToAdd, quantity: 1 });
      }
    
     },
    
    

    // Action to remove a product from the cart
    removeFromCart: (state, action) => {
      const productId = action.payload;
      state.cart = state.cart.filter((product) => product.id !== productId);
    },

    removeFromWishList: (state, action) => {
      const productId = action.payload;
      state.wishList = state.wishList.filter((product) => product.id !== productId);
    },

    removeFromCompare: (state, action) => {
      const productId = action.payload;
      state.compare = state.compare.filter((product) => product.id !== productId);
    },

    // Action to update the quantity of a product in the cart
    updateCartQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const existingProductIndex = state.cart.findIndex((product) => product.id === id);

      if (existingProductIndex !== -1) {
        state.cart[existingProductIndex].quantity = quantity;
      }
    },
     // Action to update the quantity of a product in the cart
     updateCompareQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const existingProductIndex = state.compare.findIndex((product) => product.id === id);

      if (existingProductIndex !== -1) {
        state.compare[existingProductIndex].quantity = quantity;
      }
    },
     // Action to update the quantity of a product in the cart
     updateWishListQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const existingProductIndex = state.wishList.findIndex((product) => product.id === id);

      if (existingProductIndex !== -1) {
        state.wishList[existingProductIndex].quantity = quantity;
      }
    },

    // Action to reset the cart (clear all items)
    resetCart: (state) => {
      state.cart = [];
    },
    resetCompare: (state) => {
      state.compare = [];
    },
    resetWishList: (state) => {
      state.wishList = [];
    },
  },
});

// Exporting the actions for use
export const { 
  setProduct, 
  setProducts, 
  setProductsStore,
  setSelectedProduct,
  setSelectedProductStore,
  selectedPayemntMethode,
  resetProduct, 
  resetProducts, 
  addProduct, 
  updateProduct, 
  addToCart,
  addToCompare, 
  addToWishList, 
 
  removeFromCart, 
  removeFromWishList, 
  removeFromCompare, 


  updateCartQuantity, 
  updateCompareQuantity,
  updateWishListQuantity,

  resetCart ,
  resetCompare ,
  resetWishList 

} = productSlice.actions;

// Exporting the reducer to be used in the store
export default productSlice.reducer;
